import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { egiRoutes } from '@/app/egi.pages/routes';
import { CoreModule } from '@/app/core/core.module';
import { EgiPagesModule } from '@/app/egi.pages/egi.pages.module';
import { genericAppIndexId } from '@/app/egi.pages/app-root.pages/page-ids';
import { EgiPageFrameworkModule, EgiRouterOptions } from '@ervo/page-framework';

export const APP_ROUTER_OPTIONS: EgiRouterOptions = {
  useHash: true,
  paramsInheritanceStrategy: 'always'
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EgiPageFrameworkModule.forRoot(egiRoutes, genericAppIndexId, CoreModule.routes, APP_ROUTER_OPTIONS),
    CoreModule,
    EgiPagesModule
  ]
})
export class AppRouterModule {}
